import { render, staticRenderFns } from "./LinkBuilderSettings.vue?vue&type=template&id=18a6f194&scoped=true"
import script from "./LinkBuilderSettings.vue?vue&type=script&lang=js"
export * from "./LinkBuilderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6f194",
  null
  
)

export default component.exports